import { NavigationBuilderContext } from './types';
import { LabelId, useUserPageContextState } from '../user';
import { CandidateUserStrategy } from './config/candidate/strategy';
import { entityTypeIds } from '../../utils/const';
import { CommonNavigationStrategy } from './config/common/strategy';
import { useStyleContextState } from '../styleContext';
import { CaoWijzerLabelStrategy } from './config/caoWijzer/strategy';
import { EmployerUserStrategy } from './config/employer/strategy';
import { PlatformNavigationStrategy } from './config/platform/strategy';

const resolveStrategy = ({ labelId, organizationTypeId, organizationId }: NavigationBuilderContext) => {
	if (labelId === LabelId.CaoWijzer) {
		return new CaoWijzerLabelStrategy();
	}

	if (organizationTypeId === entityTypeIds.CANDIDATE) {
		return new CandidateUserStrategy(organizationId);
	}

	if (organizationTypeId === entityTypeIds.EMPLOYER) {
		return new EmployerUserStrategy();
	}

	if (
		organizationTypeId === entityTypeIds.PLATFORM_USER
		|| organizationTypeId === entityTypeIds.AGENCY
		|| organizationTypeId === entityTypeIds.CUSTOMER_ADMIN
	) {
		return new PlatformNavigationStrategy();
	}

	return new CommonNavigationStrategy();
};

export const useNavigationStrategyResolver = () => {
	const { labelId } = useStyleContextState();
	const { organizationTypeId, organizationId } = useUserPageContextState();

	return resolveStrategy({ labelId, organizationTypeId, organizationId });
};

